module.exports = __webpack_public_path__ + "img/image2.370a236e.jpeg";